import Vue from 'vue'
import VueRouter from 'vue-router'

import HomePage from '@/views/home'
import staffPage from '@/views/home/staff.vue'
import LoginPage from '@/views/login'
import SignPage from '@/views/signUp'
import SignInPage from '@/views/signIn'
import PaperPage from '@/views/paper'
import MeetPage from '@/views/meet'
import meetLevel from '@/views/meet/meet-level'
import meetInformList from '@/views/meet/meet-inform-list'
import meetNoticeList from '@/views/meet/meet-notice-list'
import meetAffairList from '@/views/meet/meet-affairs-list'
import meetAgendaList from '@/views/meet/meet-agenda-list'
import meetHotelList from '@/views/meet/meet-hotel-list'
import meetSiteList from '@/views/meet/meet-site-list'

import meetDetail from '@/views/meet/details'
import noticeDetail from '@/views/meet/details/noticedetail'
import diningDetail from '@/views/meet/details/diningdetail'
import hintDetail from '@/views/meet/details/hintdetail'
import hotelDetail from '@/views/meet/details/hoteldetail'
import scheduleDetail from '@/views/meet/details/scheduledetail'
import linkDetail from '@/views/meet/details/linkdetail'
import guestDetail from '@/views/meet/details/guestdetail'
import trafficDetail from '@/views/meet/details/trafficdetail'
import introDetail from '@/views/meet/details/introdetail'
import transhipDetail from '@/views/meet/details/transhipdetail'

import PayPage from '@/views/pay'
import WechatPay from '@/views/pay/wechatPay'
import VisitPage from '@/views/visit'
import VisitDetailPage from '@/views/visit/details.vue'
import NeedInfo from '@/views/paper/need.vue'
import Contributions from '@/views/paper/contributions.vue'
import PaperDetails from '@/views/paper/details.vue'
import DownloadPaper from '@/views/paper/download'
import PaperSubmitType from "@/views/paper/paperSubmitType"
import LoginSuccess from '@/views/login/loginSuccess.vue'
import SubmitType from '@/views/signUp/submitType.vue'
import Info from '@/views/signUp/info.vue'
import EditInfo from '@/views/signUp/editInfo.vue'
import Refund from '@/views/signUp/refund.vue'
import Invoice from '@/views/signUp/invoice.vue'
import ScanFail from '@/views/home/components/scanFail'
import ScanSuccess from '@/views/home/components/scanSuccess'
import HotelInfo from '@/views/meet/hotel.vue'



Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'login',
  //   component: LoginPage
  // },
  {
    path: "/login",
    name: "login",
    component: LoginPage,
  },
  // {
  //   path: '/home',
  //   name: 'home',
  //   component: HomePage
  // },
  {
    path: "/",
    name: "home",
    component: HomePage,
  },
  {
    path: "/staff",
    name: "staff",
    component: staffPage,
  },
  {
    path: "/payPage",
    name: "pay",
    component: PayPage,
  },
  {
    path: "/wechatpay",
    name: "WechatPayView",
    component: WechatPay,
  },
  {
    path: "/meetPage",
    name: "meet",
    component: MeetPage,
  },
  {
    path: "/meetLevel",
    name: "meetlevel",
    component: meetLevel,
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/meetInformList",
    name: "meetinformlist",
    component: meetInformList,
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/meetNoticeList",
    name: "meetnoticelist",
    component: meetNoticeList,
    meta: {
      keepAlive: true,
    },
  },
  // 会务安排
  {
    path: "/meetAffairList",
    name: "meetaffairlist",
    component: meetAffairList,
    meta: {
      keepAlive: true,
    },
  },
  // 会议日程
  {
    path: "/meetAgendaList",
    name: "meetagendalist",
    component: meetAgendaList,
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/meetHotelList",
    name: "meethotellist",
    component: meetHotelList,
    meta: {
      keepAlive: true,
    },
  },
  //会场信息
  {
    path: "/meetSiteList",
    name: "meetsitelist",
    component: meetSiteList,
    meta: {
      keepAlive: true,
    },
  },

  {
    path: "/meetDetail",
    name: "meetdetail",
    component: meetDetail,
  },
  {
    path: "/noticeDetail",
    name: "noticedetail",
    component: noticeDetail,
  },
  //温馨提示
  {
    path: "/hintDetail",
    name: "hintdetail",
    component: hintDetail,
  },
  //用餐安排
  {
    path: "/diningDetail",
    name: "diningdetail",
    component: diningDetail,
  },
  //嘉宾信息
  {
    path: "/guestDetail",
    name: "guestdetail",
    component: guestDetail,
  },
  //酒店信息
  {
    path: "/hotelDetail",
    name: "hoteldetail",
    component: hotelDetail,
  },
  //会议日程
  {
    path: "/scheduleDetail",
    name: "scheduledetail",
    component: scheduleDetail,
  },
  //联系我们
  {
    path: "/linkDetail",
    name: "linkdetail",
    component: linkDetail,
  },
  //交通信息
  {
    path: "/trafficDetail",
    name: "trafficdetail",
    component: trafficDetail,
  },
  //会场介绍
  {
    path: "/introDetail",
    name: "introdetail",
    component: introDetail,
  },
  //接驳安排
  {
    path: "/transhipDetail",
    name: "transhipdetail",
    component: transhipDetail,
  },

  {
    path: "/hotel",
    name: "hotel",
    component: HotelInfo,
  },

  {
    path: "/visitPage",
    name: "visit",
    component: VisitPage,
  },
  {
    path: "/visitDetail",
    name: "visitDetailPage",
    component: VisitDetailPage,
  },

  {
    path: "/paper",
    name: "paper",
    component: PaperPage,
  },
  {
    path: "/paperDetails",
    name: "paperDetails",
    component: PaperDetails,
  },
  {
    path: "/contributions",
    name: "contributions",
    component: Contributions,
  },
  {
    path: "/downloadpaper",
    name: "downloadPaper",
    component: DownloadPaper,
  },
  {
    path: "/needInfo",
    name: "needInfo",
    component: NeedInfo,
  },
  {
    path: "/paperSubmitType",
    name: "paperSubmitType",
    component: PaperSubmitType,
  },

  {
    path: "/loginSuccess",
    name: "loginSuccess",
    component: LoginSuccess,
  },
  {
    path: "/signUp",
    name: "signUp",
    component: SignPage,
  },
  {
    path: "/signIn",
    name: "signIn",
    component: SignInPage,
  },

  {
    path: "/submitType",
    name: "submitType",
    component: SubmitType,
  },
  {
    path: "/info",
    name: "info",
    component: Info,
  },
  {
    path: "/editInfo",
    name: "editInfo",
    component: EditInfo,
  },
  {
    path: "/refund",
    name: "refund",
    component: Refund,
  },
  {
    path: "/invoice",
    name: "invoice",
    component: Invoice,
  },
  {
    path: "/scanSuccess",
    name: "scanSuccess",
    component: ScanSuccess,
  },
  {
    path: "/scanFail",
    name: "scanFail",
    component: ScanFail,
  },
]

const router = new VueRouter({
  routes
})

export default router

